module.exports = __webpack_public_path__ + "static/media/kokkaany3.52d9f166.avif";